import React, { useCallback, useEffect, useRef, useState } from 'react';
import { PopupMenu, Tooltip, Button, Icon } from '@doxyme/ui';
import { onCallMenuOpen } from '../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { CallMenu } from '../CallMenu';
import * as troubleshooting from '../../../troubleshooting';
import { usePrevious } from '../../../../common/hooks';
import { useIntl } from 'react-intl';
import { noop } from 'lodash';
const TOOLTIP_SHOW_DELAY_MS = 1.5;
const KebabFab = React.forwardRef(({ isDisabled = false, ariaLabel, isExpanded = false }, ref) => (<Button ref={ref} color="none" iconOnly shape="round" className={`ui-fab${isDisabled ? ' ui-fab--disabled' : ''}`} disabled={isDisabled} aria-label={ariaLabel} aria-haspopup="menu" aria-expanded={isExpanded}>
      <Icon name="menu-kebab" size="small"/>
    </Button>));
KebabFab.displayName = 'KebabFab';
export const CallMenuButton = ({ onToggle = noop, hasTooltip = true, isPatient, }) => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const isTroubleshootingActive = !!useSelector(troubleshooting.selectors.getStepName);
    const prevIsTroubleshootingActive = usePrevious(isTroubleshootingActive);
    const popupMenuRef = useRef();
    const menuButtonRef = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const focusMenuButton = useCallback(() => {
        menuButtonRef.current?.focus();
    }, []);
    const togglePopupMenu = useCallback((isOn) => {
        popupMenuRef.current?.toggleMenu(isOn);
        if (isOn === false) {
            focusMenuButton();
        }
    }, [focusMenuButton]);
    useEffect(() => {
        if (isTroubleshootingActive) {
            togglePopupMenu(true);
        }
        else if (prevIsTroubleshootingActive) {
            togglePopupMenu(false);
        }
    }, [isTroubleshootingActive, prevIsTroubleshootingActive]);
    const onTogglePopupMenu = useCallback((isOpen) => {
        setIsMenuOpen(isOpen);
        onToggle(isOpen);
        if (isOpen) {
            dispatch(onCallMenuOpen());
        }
        else {
            focusMenuButton();
        }
    }, [onToggle, dispatch, focusMenuButton]);
    const onTroubleshootingClose = useCallback(() => {
        togglePopupMenu(false);
    }, [togglePopupMenu]);
    const isDisabled = isTroubleshootingActive;
    const menuButtonLabel = intl.formatMessage({
        id: 'call.actions.options.label',
    });
    return (<PopupMenu onToggle={onTogglePopupMenu} ref={popupMenuRef} isDisabled={isDisabled} anchorEl={hasTooltip ? (<Tooltip showTimeout={TOOLTIP_SHOW_DELAY_MS} size="medium" theme="grey" pointerPosition="top-center" positionShift={7} isInteractive={false} borderRadius={16} isDefaultTriggerPadding={false} content={menuButtonLabel}>
            <KebabFab ref={menuButtonRef} isDisabled={isDisabled} ariaLabel={menuButtonLabel} isExpanded={isMenuOpen}/>
          </Tooltip>) : (<KebabFab ref={menuButtonRef} isDisabled={isDisabled} ariaLabel={menuButtonLabel} isExpanded={isMenuOpen}/>)}>
      {!isTroubleshootingActive ? (<CallMenu toggleMenu={togglePopupMenu} isPatient={isPatient}/>) : (<troubleshooting.TroubleshootingWizard isPatient={isPatient} onClose={onTroubleshootingClose}/>)}
    </PopupMenu>);
};
